import { authApiService } from '@/api/authApiService';
import { ApiResponseType, BaseResponseType } from '@/types/sharedTypes';
import { CreateRecipientPayloadType } from '../organization/wires/createRecipientApi';

export const createRecipientByProxyApi = (
  wireId: string,
  data: CreateRecipientPayloadType
): Promise<ApiResponseType<BaseResponseType>> => {
  const uri = `/recipient/wires/${wireId}/recipient/`;

  return authApiService.POST(uri, data);
};
